"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var scenario_node_footer_button_box_styles_1 = require("./scenario-node-footer-button-box.styles");

var ScenarioNodeFooterButtonBox = function ScenarioNodeFooterButtonBox(_ref) {
  var preButtonColor = _ref.preButtonColor,
      initButtonColor = _ref.initButtonColor,
      onPreClick = _ref.onPreClick,
      onInitClick = _ref.onInitClick;
  return react_1.default.createElement(scenario_node_footer_button_box_styles_1.ButtonBoxDiv, null, react_1.default.createElement(scenario_node_footer_button_box_styles_1.StyledParagraph, {
    backgroundColor: preButtonColor,
    onClick: onPreClick,
    clickable: !!onPreClick
  }, "\u4E00\u3064\u524D\u306B\u623B\u308B"), react_1.default.createElement(scenario_node_footer_button_box_styles_1.StyledParagraph, {
    backgroundColor: initButtonColor,
    onClick: onInitClick,
    clickable: !!onInitClick
  }, "\u6700\u521D\u304B\u3089"));
};

exports.default = ScenarioNodeFooterButtonBox;